import { IBookingCalendarPassengerDto, IPassengerDto } from "../../dto";
import { PassengerEligibleEnum } from "../../enums";

const getPassengerEligibleStatus = (
  passenger: IPassengerDto,
): PassengerEligibleEnum | undefined => {
  if (passenger.eligible) {
    return passenger.eligible;
  }

  if (passenger.isEligible === undefined) {
    return undefined;
  }

  if (!passenger.isEligible) {
    return PassengerEligibleEnum.notEligible;
  }

  if (passenger.metadata?.disableHoursIds?.length) {
    return PassengerEligibleEnum.eligibleWithLimitations;
  }

  return PassengerEligibleEnum.eligible;
};

export const getBookingCalendarPasssengerDto = (
  passenger: IPassengerDto,
): IBookingCalendarPassengerDto => ({
  passengerId: passenger.id,
  passengerName: `${passenger.firstName} ${passenger.lastName}`,
  phoneMobile: passenger.phoneMobile,
  unitId: passenger.unitId,
  unitName: passenger.unitName,
  code: passenger.code,
  fromStation1AreaName: passenger.fromStation1AreaName,
  fromStation2AreaName: passenger.fromStation2AreaName,
  isActive: passenger.isActive,
  eligible: getPassengerEligibleStatus(passenger),
  passengerTypeName: passenger.passengerTypeName,
  referent: passenger.referent,
});
